import React from 'react';
import { Form, Col, Row, Typography } from 'antd';
import { I18n } from '@aws-amplify/core';
import { ErgonomicTool } from './ErgonomicTool';
import { useHandleTools } from '@/components/Settings/DataExtraction/Content/hooks/useHandleTools';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import { FormItemWrapper, BodyLargeRegular } from '@/components/Settings/DataExtraction/styles';
import * as S from '../styles';

const { useWatch } = Form;

export function Tools() {
	const form = Form.useFormInstance();
	const selectedTools = useWatch(['tools', 'selected_tools'], form) || [];
	const tools = useHandleTools();
	const { dataExtractionReport } = useDataExtractionReport();

	const reportCount = dataExtractionReport?.data_extraction_reports?.length || 0;
	const reportType = dataExtractionReport?.custom_report?.name;
	const isAllSelected = tools.length > 0 && tools.every((tool) => selectedTools.includes(tool.ergonomic_tool_id));

	const handleSelectAll = () => {
		const newSelection = isAllSelected ? [] : tools.map((tool) => tool.ergonomic_tool_id);
		form.setFieldValue(['tools', 'selected_tools'], newSelection);
	};

	if (!tools?.length) {
		return null;
	}

	const toolsGrid = (
		<FormItemWrapper name={['tools', 'selected_tools']}>
			<S.StyledCheckboxGroup>
				<S.ToolsGrid>
					{tools.map((tool, index) => (
						<ErgonomicTool key={tool.ergonomic_tool_id || `tool-${index}`} tool={tool} />
					))}
				</S.ToolsGrid>
			</S.StyledCheckboxGroup>
		</FormItemWrapper>
	);

	return (
		<>
			<Row justify="space-between" align="middle" gutter={[0, 24]}>
				<Col>
					{reportCount > 0 && (
						<BodyLargeRegular>
							{I18n.get('Showing the available tools in')} {reportCount} {I18n.get('report')}
							{reportCount > 1 ? 's' : ''} {reportType}:
						</BodyLargeRegular>
					)}
				</Col>
				<Col>
					<Typography.Link onClick={handleSelectAll}>
						{isAllSelected ? I18n.get('Deselect all') : I18n.get('Select all')}
					</Typography.Link>
				</Col>
				<S.ToolsContainer>{toolsGrid}</S.ToolsContainer>
			</Row>
		</>
	);
}
